// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"40":"b8d6d67c","44":"c4dd10fd","91":"a622cd60","99":"e021d584","326":"ae635b3a","390":"36467fae","556":"f06607d9","682":"e8b7a76e","751":"3165f980","758":"d03f282a","970":"12e6df47"}[chunkId] + ".js";
};